<div class="start-transport-pause-dialog mat-body">

  <div class="dialog-layout">

    <h2 class="dialog-h2">
      {{'start pause' | translate: ['tmc.visit.overview.start-transport-pause-dialog.title',
      translationService.language]}}
    </h2>
    <i class="horizontal-divider"></i>

    <div class="top-info">
      <app-transport-info-panel [carrier]="data.carrier" [identifier]="data.identifier" [driver]="data.name"
        [scope]="data.transportScope"></app-transport-info-panel>
    </div>

    <div class="dialog-content">
      <mat-form-field class="end-time">
        <input matInput
          placeholder="{{'end' | translate: ['tmc.visit.overview.start-transport-pause-dialog.end', translationService.language]}}"
          [(ngModel)]="end" type="datetime-local">
      </mat-form-field>

      <app-dictionary-key-select [selectedIndex]="0" (selectionChanged)="optionsChanged($event)"
        placeholder="{{'select cause' | translate: ['tmc.visit.overview.start-transport-pause-dialog.cause.title', translationService.language]}}"
        [rootKey]="'tmc.visit.overview.start-transport-pause-dialog.cause.options'" [required]="true">
      </app-dictionary-key-select>

      <mat-form-field class="textarea-note">
        <textarea
          placeholder="{{'note' | translate: ['tmc.visit.overview.start-transport-pause-dialog.note', translationService.language]}}"
          matInput [(ngModel)]="note" [required]="cps.isRequired('visitoverview.delete.length.cause', false)"
          [maxlength]="9999" cdkTextareaAutosize cdkAutosizeMinRows="5" cdkAutosizeMaxRows="15">
        </textarea>
      </mat-form-field>

      <app-service-response [responseMessages]="responseMessages"></app-service-response>
    </div>

    <i class="horizontal-divider"></i>

    <sc-actionbar>
      <sc-content-spacer [grow]="true"></sc-content-spacer>
      <button mat-stroked-button class="cancel-button" (click)="cancelDialog()" [disabled]="isCancelDisabled()">{{'cancel'
        | translate:['shared.selection-dialog.action.cancel', translationService.language]}}</button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button class="confirm-button" (click)="confirm()" [disabled]="isConfirmDisabled()">{{'confirm'
        | translate:['tmc.visit.overview.start-transport-pause-dialog.button.start',
        translationService.language]}}</button>
    </sc-actionbar>
  </div>
</div>